<template>
    <transition name="box" mode="out-in" appear type="animation">
        <div id="confirm" @animationend="handleAnimationEnd" :class="confirmClass || ''" v-show="visible" @touchmove.prevent @wheel.prevent>
            <div class="confirm-content" @click.stop>
                <div class="top-bar"></div>
                <div class="title">{{title || '提示'}}</div>
                <div class="message" v-if="message">
                    {{message.trim()}}
                </div>
                <div class="buttons">
                    <div class="button-item cancel" @click="handleCancel">{{cancleText || '取消'}}</div>
                    <div class="button-item confirm" @click="handleConfirm">{{confirmText || '确定'}}</div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    data () {
        return {
            title: '',
            message: '',
            btn: '',
            confirmClass: '',
            cancleText: '',
            confirmText: '',
            visible: false,
        }
    },
    watch: {
        '$route' () {
            this.close()
        }
    },
    methods: {
        close () {
            this.visible = false
        },
        handleAnimationEnd () {
            if (!this.visible) {
                this.title = ''
                this.message = ''
                this.btn = ''
                this.confirmClass = ''
                this.cancleText = ''
                this.confirmText = ''
            }
        },
        handleCancel () {
            this.close()
            this._promise && this._promise.reject()
        },
        handleConfirm () {
            this.close()
            this._promise && this._promise.resolve()
        }
    },
}
</script>

<style lang="less" scoped>
@keyframes Show {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
@keyframes Hide {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}
#confirm {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 200;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    &.box-enter-active {
        animation-name: Show;
        animation-duration: 0.3s;
        animation-fill-mode: both;
    }
    &.box-leave-active {
        animation-name: Hide;
        animation-duration: 0.3s;
        animation-fill-mode: both;
    }
    .confirm-content {
        background-color: #fff;
        border-radius: 0.4rem;
        width: 78%;
        max-width: 450px;
        overflow: hidden;
        .top-bar {
            height: 1.2rem;
            background-image: linear-gradient(270deg, #99D5FF 0%, #3355FF 100%);
        }
        .title, .message {
            padding: 0 2.4rem;
            margin: 2.4rem 0;
        }
        .title {
            font-size: @font-size-base;
            font-weight: bold;
            text-align: justify;
        }
        .message {
            white-space: pre-line;
        }
        .buttons {
            display: flex;
            justify-content: space-between;
            padding: 0 2.4rem;
            margin: 3.2rem 0 2.4rem;
            .button-item {
                font-size: @font-size-base;
                padding: 1rem 0;
                border-radius: 0.2rem;
                width: calc(50% - 0.5rem);
                max-width: 11.5rem;
                text-align: center;
                &:hover {
                    opacity: 0.85;
                    transition: opacity 0.2s ease-in-out;
                }
                &.cancel {
                    color: @btn-text-color-disable;
                    background-color: @btn-fill-disable;
                }
                &.confirm {
                    color: @btn-fill-primary;
                    background-color: @btn-fill-weakened;
                }
            }
        }
    }
}
</style>